/**
 * Human-friendly labels for tool/task ids so headers don't show
 * "apps" or "app-gmail" verbatim. Used by OrbitDock today and by
 * any future surface that wants to show "what is Orbit doing?"
 *
 * Falls back to the raw `task.label` if no mapping exists.
 */

export interface TaskRef {
  id: string;
  label?: string;
  detail?: string;
  meta?: { provider?: string; [k: string]: any } | null;
}

export const PHASE_LABELS: Record<string, (detail?: string) => string> = {
  // Tools the user should see narrated
  connectApp:               () => 'Preparing connection\u2026',
  researchBusiness:         () => 'Reading your business\u2026',
  saveBusinessIntelligence: () => 'Saving your profile\u2026',
  startBackgroundCrawl:     () => 'Indexing your site\u2026',
  embedIntelligence:        () => 'Indexing intelligence\u2026',
  updateIntelligenceField:  () => 'Updating your profile\u2026',
  proposeConnections:       () => 'Finding tools to connect\u2026',
  lookupClient:             () => 'Looking up your account\u2026',
  createClient:             () => 'Creating your account\u2026',
  updateClient:             () => 'Updating your account\u2026',
  importReposAsAgents:      () => 'Importing your repositories\u2026',
  searchWeb:                () => 'Searching the web\u2026',
  checkProfileCompletion:   () => 'Scoring your profile\u2026',
  getPlaybookCompleteness:  () => 'Checking your playbook\u2026',
  suggestNextSteps:         () => 'Tailoring next steps\u2026',
};

export function phaseLabelFor(task: TaskRef): string {
  // app-specific connect tasks carry provider in meta — give them a dedicated label
  if (task.id?.startsWith('app-') && task.meta?.provider) {
    const provider = String(task.meta.provider);
    const Nice = provider.charAt(0).toUpperCase() + provider.slice(1).replace(/_/g, ' ');
    if (task.detail) return `${Nice} \u00b7 ${task.detail.toLowerCase()}`;
    return `Connecting ${Nice}\u2026`;
  }
  const mapper = PHASE_LABELS[task.id];
  if (mapper) return mapper(task.detail);
  if (task.label) return task.detail ? `${task.label} \u00b7 ${task.detail}` : task.label;
  return 'Working\u2026';
}
